import { useTranslation } from 'react-i18next';

import { Button, Paragraph } from '@app/shared/ui/atoms/Common';

interface PlaceholderBannerProps {
  placeholder: string;
  buttonText?: string;
  onBtnClick?: () => void;
}

export function PlaceholderBanner({ placeholder, buttonText, onBtnClick }: PlaceholderBannerProps) {
  const { t } = useTranslation();

  return (
    <>
      <Paragraph variant="white" className="whitespace-pre-line text-lg text-shadow-dark">
        {t(placeholder)}
      </Paragraph>
      {buttonText && (
        <Button className="px-2" shadow="cyan" onClick={onBtnClick}>
          {t(buttonText)}
        </Button>
      )}
    </>
  );
}
